"use strict";

exports.__esModule = true;
exports.default = void 0;

/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var ConditionalFormattingAPI = /*#__PURE__*/function () {
  function ConditionalFormattingAPI() {}

  var _proto = ConditionalFormattingAPI.prototype;

  /**
   * @function ConditionalFormattingAPI#isEnabled
   * @description checks to see if the feature is enabled
   * @return {Boolean}
  */
  _proto.isEnabled = function isEnabled() {}
  /**
   * @function ConditionalFormattingAPI#initializeFeature
   * @description Initializes the caches needed by the conditional formatting feature
   * @return {Promise}
   */
  ;

  _proto.initializeFeature = function initializeFeature() {}
  /**
   * @function ConditionalFormattingAPI#getFormatting
   * @description Get the formatting information to be applied
   * @param {object} conditionalFormatting
   * @param {number} baseValue The base value to use to find the correct formatting information
   * @param {number} [targetValue] The target value.  Only needed if using percent based conditions
   * @return {object} An Object containing color and shape properties.
   * If no formatting was found for the provided values then null will be returned
   */
  ;

  _proto.getFormatting = function getFormatting() {}
  /**
   * @function ConditionalFormattingAPI#getConditionalFormatMeasures
   * @description Gets the conditional formats
   * @param {Array} - An array of the conditional formats
   */
  ;

  _proto.getConditionalFormatMeasures = function getConditionalFormatMeasures() {}
  /**
   * @function ConditionalFormattingAPI#setColorBy
   * @description Sets the conditional palette id
   * @param {String} dataItemId - DataItem id used to get conditional format used to the set the color by
   * @param {String} colorByDataItemId - the new ColorBy
   */
  ;

  _proto.setColorBy = function setColorBy() {}
  /**
   * @function ConditionalFormattingAPI#getColorBy
   * @description Get the ColorBy for conditional formatting associated to the dataItemId
   * @param {String} dataItemId - DataItem id used to get conditional format used to the get the color by
   * @return {string} the color by
   */
  ;

  _proto.getColorBy = function getColorBy() {}
  /**
   * @function ConditionalFormattingAPI#setScale
   * @description Sets the conditional palette id
   * @param {String} dataItemId - DataItem id used to get conditional format used to the set the scale
   * @param {RULE_SCALES} scale - the new scale
   */
  ;

  _proto.setScale = function setScale() {}
  /**
   * @function ConditionalFormattingAPI#getScale
   * @description Get the Scale for conditional formatting associated to the dataItemId
   * @param {String} dataItemId - DataItem id used to get conditional format used to the get the scale
   * @return {RULE_SCALES} - The scale
   */
  ;

  _proto.getScale = function getScale() {}
  /**
   * @function ConditionalFormattingAPI#setPaletteId
   * @description Sets the conditional palette id
   * @param {String} dataItemId - DataItem id used to get conditional format used to the set the palette id
   * @param {String} paletteId - the new palette id
   */
  ;

  _proto.setPaletteId = function setPaletteId() {}
  /**
   * @function ConditionalFormattingAPI#getPaletteId
   * @description Get the palette for conditional formatting associated to the dataItemId
   * @param {String} dataItemId - DataItem id used to get conditional format used to the get the pallette id
   * @return {string} - The palette id
   */
  ;

  _proto.getPaletteId = function getPaletteId() {}
  /**
   * @function ConditionalFormattingAPI#setSummaryFillColor
   * @description Sets the fill color of the summary
   * @param {String} hexColor - the new summary fill color
   */
  ;

  _proto.setSummaryFillColor = function setSummaryFillColor() {}
  /**
   * @function ConditionalFormattingAPI#getSummaryFillColor
   * @description Gets the fill color of the summary
   * @return {string} - the summary fill color
   */
  ;

  _proto.getSummaryFillColor = function getSummaryFillColor() {}
  /**
   * @function ConditionalFormattingAPI#setBackgroundOpacity
   * @description Sets the conditional palette id
   * @param {String} dataItemId - DataItem id used to get conditional format used to the set the opacity
   * @param {String} opacity - the new opacity
   */
  ;

  _proto.setBackgroundOpacity = function setBackgroundOpacity() {}
  /**
   * @function ConditionalFormattingAPI#getBackgroundOpacity
   * @description Get the backgroundOpacity for conditional formatting associated to the dataItemId
   * @param {String} dataItemId - DataItem id used to get conditional format used to the get the opacity
   * @return {string} the opacity
   */
  ;

  _proto.getBackgroundOpacity = function getBackgroundOpacity() {}
  /**
   * @function ConditionalFormattingAPI#getNumberOfRules
   * @description Returns the number of ranges
   * @param {String} dataItemId - DataItem id used to get conditional format used to the get the number of rules
   * @return {number} number of rules
   */
  ;

  _proto.getNumberOfRules = function getNumberOfRules() {}
  /**
   * @function ConditionalFormattingAPI#addRule
   * @description creates a specified type of rule for the conditional format associated with the dataItemId. Adds at the end if a valid index is not specified, otherwise inserts at index
   * @param {String} dataItemId - DataItem id used to get conditional format used to add a rule
   * @param {Number} ruleIndex - An index number for the rule that needs to be added.
   * @param {RULE_TYPES} ruleType - the type of rule to create or the rule to add
   */
  ;

  _proto.addRule = function addRule() {}
  /**
   * @function ConditionalFormattingAPI#deleteRule
   * @description creates a specified type of rule for the conditional format associated with the dataItemId
   * @param {String} dataItemId - DataItem id used to get conditional format used to delete a rule
   * @param {Number} ruleIndex - An index number for the rule that needs to be deleted
   */
  ;

  _proto.deleteRule = function deleteRule() {}
  /**
   * @function ConditionalFormattingAPI#moveRule
   * @description reordering the conditionalFormattings with given indexes order
   * @param {String} dataItemId - DataItem id used to get conditional format used to the reorder rules
   * @param {Number} fromIndex - An index number for the rule that needs to be moved
   * @param {Number} toIndex - An index number for where the rule should be moved to
   */
  ;

  _proto.moveRule = function moveRule() {}
  /**
   * @function ConditionalFormattingAPI#setRangeOperator
   * @description sets the rule range operator.
   * @param {String} dataItemId - DataItem id used to get conditional format used to the set the range operator
   * @param {Number} ruleIndex - An index number for the rule that needs to be deleted
   * @param {RangeOperators} type - the type of range operator to create
   */
  ;

  _proto.setRangeOperator = function setRangeOperator() {}
  /**
   * @function ConditionalFormattingAPI#getRangeOperator
   * @description gets the range rule operator
   * @param {String} dataItemId - DataItem id used to get conditional format used to the get the range operator
   * @param {Number} ruleIndex - An index number for the rule that needs to be deleted
   * @return {RangeOperators} The range operator
   */
  ;

  _proto.getRangeOperator = function getRangeOperator() {}
  /**
   * @function ConditionalFormattingAPI#setRuleStartConditionType
   * @description sets the rule start condition type
   * @param {String} dataItemId - DataItem id used to get conditional format used to the set the start rule type
   * @param {Number} ruleIndex - An index number for the rule that needs to be deleted
   * @param {RULE_OPERATORS} type - The operator type of the start condition
   */
  ;

  _proto.setRuleStartConditionType = function setRuleStartConditionType() {}
  /**
   * @function ConditionalFormattingAPI#getRuleStartConditionType
   * @description gets the rule start condition type
   * @param {String} dataItemId - DataItem id used to get conditional format used to the get the start rule type
   * @param {Number} ruleIndex - An index number for the rule that needs to be deleted
   * @return {RULE_OPERATORS} The operator type of the start condition
   */
  ;

  _proto.getRuleStartConditionType = function getRuleStartConditionType() {}
  /**
   * @function ConditionalFormattingAPI#setRuleStartConditionValue
   * @description sets the rule start condition value
   * @param {String} dataItemId - DataItem id used to get conditional format used to the set the start rule value
   * @param {Number} ruleIndex - An index number for the rule that needs to be deleted
   * @param {Number} value - Value of the start condition
   */
  ;

  _proto.setRuleStartConditionValue = function setRuleStartConditionValue() {}
  /**
   * @function ConditionalFormattingAPI#getRuleStartConditionValue
   * @description gets the rule start condition value
   * @param {String} dataItemId - DataItem id used to get conditional format used to the set the start rule value
   * @param {Number} ruleIndex - An index number for the rule that needs to be deleted
   * @return {Number} - Value of the start condition
   */
  ;

  _proto.getRuleStartConditionValue = function getRuleStartConditionValue() {}
  /**
   * @function ConditionalFormattingAPI#setRuleEndConditionType
   * @description sets the rule end condition type
   * @param {String} dataItemId - DataItem id used to get conditional format used to the set the end rule type
   * @param {Number} ruleIndex - An index number for the rule that needs to be deleted
   * @param {RULE_OPERATORS} type - The operator type of the end condition
   */
  ;

  _proto.setRuleEndConditionType = function setRuleEndConditionType() {}
  /**
   * @function ConditionalFormattingAPI#getRuleEndConditionType
   * @description gets the rule end condition type
   * @param {String} dataItemId - DataItem id used to get conditional format used to the get the end rule type
   * @param {Number} ruleIndex - An index number for the rule that needs to be deleted
   * @return {RULE_OPERATORS} - The operator type of the end condition
   */
  ;

  _proto.getRuleEndConditionType = function getRuleEndConditionType() {}
  /**
   * @function ConditionalFormattingAPI#setRuleEndConditionValue
   * @description sets the rule end condition value
   * @param {String} dataItemId - DataItem id used to get conditional format used to the set the end rule value
   * @param {Number} ruleIndex - An index number for the rule that needs to be deleted
   * @param {Number} value - The value of the end condition
   */
  ;

  _proto.setRuleEndConditionValue = function setRuleEndConditionValue() {}
  /**
   * @function ConditionalFormattingAPI#getRuleEndConditionValue
   * @description gets the rule end condition value
   * @param {String} dataItemId - DataItem id used to get conditional format used to the get the end rule value
   * @param {Number} ruleIndex - An index number for the rule that needs to be deleted
   * @return {Number} The value of the end condition
   */
  ;

  _proto.getRuleEndConditionValue = function getRuleEndConditionValue() {}
  /**
   * @function ConditionalFormattingAPI#setRuleStyleTextColor
   * @description sets the rule style text color
   * @param {String} dataItemId - DataItem id used to get conditional format used to the set the text color
   * @param {Number} ruleIndex - An index number for the rule that needs to be deleted
   * @param {String} color - The rule style text color
   */
  ;

  _proto.setRuleStyleTextColor = function setRuleStyleTextColor() {}
  /**
   * @function ConditionalFormattingAPI#getRuleStyleTextColor
   * @description gets the rule style text color
   * @param {String} dataItemId - DataItem id used to get conditional format used to the get the text color
   * @param {Number} ruleIndex - An index number for the rule that needs to be deleted
   * @return {string} The rule style text color
   */
  ;

  _proto.getRuleStyleTextColor = function getRuleStyleTextColor() {}
  /**
   * @function ConditionalFormattingAPI#setRuleStyleFillColor
   * @description sets the rule style fill color
   * @param {String} dataItemId - DataItem id used to get conditional format used to the set the fill color
   * @param {Number} ruleIndex - An index number for the rule that needs to be deleted
   * @param {String} color - The rule style fill color
   */
  ;

  _proto.setRuleStyleFillColor = function setRuleStyleFillColor() {}
  /**
   * @function ConditionalFormattingAPI#getRuleStyleFillColor
   * @description gets the rule style fill color
   * @param {String} dataItemId - DataItem id used to get conditional format used to the get the fill color
   * @param {Number} ruleIndex - An index number for the rule that needs to be deleted
   * @return {string} The rule style fill color
   */
  ;

  _proto.getRuleStyleFillColor = function getRuleStyleFillColor() {}
  /**
   * @function ConditionalFormattingAPI#setRuleStyleShape
   * @description sets the rule style shape
   * @param {String} dataItemId - DataItem id used to get conditional format used to the set the shape
   * @param {Number} ruleIndex - An index number for the rule that needs to be deleted
   * @param {String} color - The rule style shape
   */
  ;

  _proto.setRuleStyleShape = function setRuleStyleShape() {}
  /**
   * @function ConditionalFormattingAPI#getRuleStyleShape
   * @description gets the rule style shape
   * @param {String} dataItemId - DataItem id used to get conditional format used to the get the shape
   * @param {Number} ruleIndex - An index number for the rule that needs to be deleted
   * @return {string} The rule style shape
   */
  ;

  _proto.getRuleStyleShape = function getRuleStyleShape() {}
  /**
   * @function ConditionalFormattingAPI#getPropertyLayoutList
   * @description get list of property layouts
   * @return {object[]}
   */
  ;

  _proto.getPropertyLayoutList = function getPropertyLayoutList() {}
  /**
   * @function ConditionalFormattingAPI#getDataItemFormatSpec
   * @description Returns the format spec for the colorBy dataItem for crosstab and table, or the target slot dataItem for KPI
   * @param {String} dataItemId - DataItem id used to get the conditional format
   * @return {object} the format spec
   */
  ;

  _proto.getDataItemFormatSpec = function getDataItemFormatSpec() {}
  /**
   * @function ConditionalFormattingAPI#getConditionalFormatting
   * @description Returns all the information about the conditional formatting
   * @return {object}
   */
  ;

  _proto.getConditionalFormatting = function getConditionalFormatting() {}
  /**
   * @function ConditionalFormattingAPI#getShapeDefinition
   * @description Get the shape definition for a specific range (name, icon id, label) - Internal
   * @param {string} shape - The shape name you want to get the shape definition for
   * @return {object} - The shape definition
   */
  ;

  _proto.getShapeDefinition = function getShapeDefinition() {} // Should this be a stShapeDefinition instead of a getShapeDefinition in livewidget ?

  /**
   * @function ConditionalFormattingAPI#getCustomColorList
   * @description gets the used custom colors for custom color feature
   * @return {CustomColor}
   */
  ;

  _proto.getCustomColorList = function getCustomColorList() {}
  /**
   * @function ConditionalFormattingAPI#registerProvider
   * @description Register a provider as a data point actions provider
   * @param {name} name the name of the provider
   * @param {provider} provider provider to register and contribute to conditional formatting
   */
  ;

  _proto.registerProvider = function registerProvider()
  /* provider */
  {}
  /**
   * @function ConditionalFormattingAPI#deregisterProvider
   * @description Deregister a provider as a properties provider
   * @param {name} name the name of the provider
   */
  ;

  _proto.deregisterProvider = function deregisterProvider() {};

  return ConditionalFormattingAPI;
}();

var _default = ConditionalFormattingAPI;
exports.default = _default;
